module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.8289d1a.woff2";